<template>

	<div style="width: 100%;">

		<iframe v-if="mode === 'form'" class="iframeDom" :ref="domId" :id="domId" ref="summernote_frame" frameborder="0" scrolling="yes" src="/common/summernote/summernote_form.html?mode=form"
		        width="100%" height="0" style="width: 100%; overflow-y: auto;" @load.once="setHtml" ></iframe>

		<iframe v-if="mode === 'view'" class="iframeDom" :ref="domId" :id="domId" ref="summernote_frame" frameborder="0" scrolling="yes" src="/common/summernote/summernote_view.html?mode=view"
		        width="100%" height="0" style="width: 100%; overflow-y: auto;" @load.once="setHtml" ></iframe>

	</div>

</template>

<script>

import $ from 'jquery'

export default {
	name: "summernoteFrame",
	props: {
		mode: String,
		html: String,
		targetId: String,
	},
	data () {

		let domId = "ifr-content";
		if ( this.targetId !== undefined ) {
			domId = this.targetId
		}

		return {
			domId,
		}
	},
	created() {

	},
	mounted() {

		const self = this

		this.setHtml();
		window.onload = () => this.frameResize();
		window.onresize = () => this.frameResize();
	},
	methods: {

		getHtml() {
			return $('#' + this.domId).get(0).contentWindow.getHtml();
		},

		setHtml() {

			const self = this
			let $frame = $('#' + this.domId)
			let doc = $frame[0].contentWindow.document;

			let $body = $('body', doc);

			if ( $frame.get(0).contentWindow.setHtml !== undefined ) {
				$frame.get(0).contentWindow.setHtml(self.html)
				doc.body.style.margin = 0;
			}
			this.frameResize();
		},


		frameResize( _oldSize = 0 ) {

			const self = this

			try {

				const $body = document.querySelector('#' + this.domId).contentWindow.document.body;
				if ( $body != null ) {
					var the_height = document.querySelector('#' + this.domId).contentWindow.document.body.scrollHeight;

					//change the height of the iframe
					document.querySelector('#' + this.domId).height = the_height;

					//document.getElementById('the_iframe').scrolling = "no";
					document.querySelector('#' + this.domId).style.overflowY = "hidden";

					console.log( _oldSize + "::::: iframe size ::::: " + the_height )
					if ( _oldSize !== the_height || _oldSize > the_height ) {
						setTimeout(() => {
							return self.frameResize(the_height)
						}, 800)
					}

					return the_height;
				} else {
					setTimeout(() => {
						return self.frameResize(the_height)
					}, 800)
				}
			} catch (e) {
				setTimeout(() => {
					return self.frameResize(_oldSize)
				}, 800)
			}
		},

	},
	watch: {
		'html': function (newVal) {
			console.log(newVal)
			this.setHtml()
		},
	}
}







window.addEventListener( 'message', (e) => {
	// 전달 된 데이터
	console.log( e.data.functionName );

	// 부모창의 함수 실행
	if( e.data.functionName === 'done' ) {
		doneReszie();
	}
});

function doneReszie ( _oldSize = 0 ) {

	const self = this
	const $body = document.querySelector('.iframeDom').contentWindow.document.body;
	var the_height = document.querySelector('.iframeDom').contentWindow.document.body.scrollHeight;

	//change the height of the iframe
	document.querySelector('.iframeDom').height = the_height;

	//document.getElementById('the_iframe').scrolling = "no";
	document.querySelector('.iframeDom').style.overflowY = "hidden";

	console.log( _oldSize + "::::: iframe size ::::: " + the_height )
	if ( _oldSize !== the_height || _oldSize > the_height ) {
		setTimeout(() => {
			return doneReszie(the_height)
		}, 300)
	}

	return the_height;
}



</script>

<style scoped>

</style>
